import React from "react";

// Author avatar shared by comment updates and activity events: the monday
// profile photo when there is one, otherwise a colored initials circle.
const Avatar = ({
  initials,
  color,
  photoUrl,
}: {
  initials: string;
  color: string;
  photoUrl?: string;
}) =>
  photoUrl ? (
    <img
      src={photoUrl}
      alt={initials}
      className="flex-none w-[30px] h-[30px] rounded-full object-cover"
    />
  ) : (
    <div
      className="flex-none w-[30px] h-[30px] rounded-full flex items-center justify-center text-[11px] font-bold text-white"
      style={{ background: color }}
    >
      {initials}
    </div>
  );

export default Avatar;
